import React from 'react';
import InventoryIcon from '@mui/icons-material/ImportExport';

export const inventoryIcon = (
  value: boolean,
  selected: string,
  disabled: string
) => (
  <InventoryIcon
    style={{ width: '30', marginLeft: '-8px', marginRight: '-7px', color: value ? selected : disabled }}
    id="iconMenu-icon-inventory"
  />
);
